import { DEAL_ROUTES, ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { useValuationNavigation } from '@dealstack/frontend/app/pages/Valuations/hooks/useValuationNavigation';
import { Button } from '@mantine/core';
import { generatePath, Link } from 'react-router-dom';
import { DateTime } from 'luxon';
import { DATE_FORMATS } from '@dealstack/shared/lib/format/dates/date';
import {
	useTranslationCapManage,
	useTranslationValuations,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState.tsx';

export const EmptyOwnershipStructure = ({
	valuationDate,
}: {
	valuationDate: string | undefined;
}) => {
	const { dealId } = useValuationNavigation();
	const tValuations = useTranslationValuations();
	const tCapTranslation = useTranslationCapManage();

	const formattedDate = valuationDate
		? DateTime.fromISO(valuationDate, { zone: 'utc' }).toFormat(DATE_FORMATS.UTC_TIME_ON_DATE)
		: '';

	const capTableUrl = generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.CAP_TABLE}`, {
		dealId: dealId ?? '',
	});

	return (
		<EmptyState
			icon="es-radar"
			title={tValuations('no_ownership_structure')}
			description={tValuations('no_ownership_structure_message', { date: formattedDate })}
		>
			<Link to={capTableUrl}>
				<Button variant="default">{tCapTranslation('header.button_view')}</Button>
			</Link>
		</EmptyState>
	);
};
